import React from 'react';
import styled from '@emotion/styled';

type YoutubeProps = {
  id: string;
};

const Container = styled.div`
  /* aspect-ratio: 16 / 9; */
  width: 100%;
  position: relative;
  padding-top: 56.25%;
`;
const Iframe = styled.iframe`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
`;

export const Youtube: React.FC<YoutubeProps> = props => {
  return (
    <Container>
      <Iframe
        src={`https://www.youtube.com/embed/${props.id}`}
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </Container>
  );
};
